import styled from 'styled-components';
import { EDITOR_MENU_WIDTH, EDITOR_WIDTH } from './const';
import { DashedFocusBorder } from 'jamespot-react-components';

const INPUT_HEIGHT = 50;
const RADIUS = 8;

export const CSSEditorComponentWrapper = styled.div`
    margin-bottom: 24px;
`;

export const CSSEditorComponentLabel = styled.div`
    margin-bottom: 4px;
`;

export const CSSEditorPortal = styled.div<{ isActive: boolean }>`
    position: absolute;
    background-color: ${(props) => (props.isActive ? 'rgba(0,0,0,.1)' : 'transparent')};
    inset: 0;
    pointer-events: ${(props) => (props.isActive ? 'all' : 'none')};
    flex: 1;
    display: flex;
    overflow: hidden;
`;

export const CSSEditorHeader = styled.div`
    flex-direction: row;
    display: flex;
    min-height: 60px;
    border-bottom: 1px solid ${(props) => props.theme.color.grey2};
`;

export const CSSEditorAction = styled.div`
    width: 60px;
    display: flex;
    align-items: center;
    justify-content: center;
`;

export const CSSEditorLabel = styled.div`
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
`;

// This is a mask to hide top shadow. EDITOR_WIDTH + 20 is used to keep the left shadow
export const CSSEditorMask = styled.div`
    position: relative;
    overflow: hidden;
    top: 0px;
    width: ${EDITOR_WIDTH + 20}px;
`;

export const CSSEditor = styled.div<{ position: 'left' | 'right' }>`
    position: absolute;
    top: 0;
    ${(props) => (props.position === 'left' ? 'left: 0px;' : '')}
    ${(props) => (props.position === 'right' ? 'right: -1000px;' : '')}
    width: ${EDITOR_WIDTH}px;
    bottom: 00px;
    display: flex;
    background-color: ${(props) => props.theme.color.white};
    flex-direction: row;
    transition: all 0.4s;
    box-shadow: -4px 0px 20px 0px #00000017;

    &.animate {
        right: 0px;
    }
`;

export const CSSEditorContent = styled.div`
    flex: 1;
    display: flex;
    flex-direction: column;
    padding: 12px;
    overflow: auto;
    margin-bottom: 12px;
    position: relative;
`;

export const CSSEditorTab = styled.div`
    flex: 1;
    display: flex;
    flex-direction: column;
`;

export const CSSEditorIsBusy = styled.div`
    position: absolute;
    inset: 0;
    background-color: rgba(255, 255, 255, 0.8);
    display: flex;
    align-items: center;
    justify-content: center;
`;

export const CSSEditorIsLocked = styled.div`
    position: absolute;
    inset: 0;
    background-color: ${(props) => props.theme.color.white};
    padding: ${(props) => props.theme.space.md}px;
`;

export const CSSEditorMenu = styled.div`
    width: ${EDITOR_MENU_WIDTH}px;
    padding-top: 60px;
    display: flex;
    flex-direction: column;
    border-right: 1px solid ${(props) => props.theme.color.grey2};
`;

export const CSSEditorMenuButton = styled.button<{ isActive?: boolean }>`
    border-radius: 4px;
    cursor: pointer;
    height: 42px;
    margin: 4px;
    width: 42px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: ${(props) => (props.isActive ? props.theme.color.grey2 : props.theme.color.white)};

    ${DashedFocusBorder()}

    &:hover {
        background-color: ${(props) => props.theme.color.grey2};
    }
`;

export const CSSInputWrapper = styled.div`
    display: flex;
    border: 1px solid ${(props) => props.theme.color.grey1};
    border-radius: ${RADIUS}px;
    margin-bottom: 24px;
    input {
        width: 100%;
        border: 0;
        height: ${INPUT_HEIGHT}px;
        margin: 0;
    }
`;

export const CSSEditorWidget = styled.div`
    display: flex;
    flex-direction: row;
    padding: 12px;
    background-color: ${(props) => props.theme.color.grey0};
    border-radius: 8px;
    margin-bottom: 4px;
`;

export const CSSEditorWidgetLabel = styled.div`
    display: flex;
    flex: 1;
    align-items: center;
`;

export const CSSEditorWidgetOption = styled.div`
    width: 40px;
    display: flex;
    justify-content: center;
    align-items: center;
`;

export const CSSEditorLayer = styled.div`
    flex-direction: row;
    display: flex;
    align-items: center;
`;

export const CSSEditorLayerTitle = styled.div`
    flex: 1;
    display: flex;
    align-items: center;
`;
